import { render, staticRenderFns } from "./SealApplyAdd.vue?vue&type=template&id=5b4ba8aa&scoped=true"
import script from "./SealApplyAdd.vue?vue&type=script&lang=js"
export * from "./SealApplyAdd.vue?vue&type=script&lang=js"
import style0 from "./SealApplyAdd.vue?vue&type=style&index=0&id=5b4ba8aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4ba8aa",
  null
  
)

export default component.exports